import { decodeJwt } from './utilities';

const PAYMENT_ACTION_STORAGE_KEY = 'redimdwm_payment_action';
const CAPABILITY_PATTERN = /^[a-f0-9]{64}$/;

const removeFragmentFromAddress = () => {
  const cleanUrl = `${window.location.pathname}${window.location.search}`;
  window.history.replaceState(window.history.state, '', cleanUrl);
};

export const capturePaymentCapability = () => {
  const fragment = window.location.hash;
  if (!fragment) return null;

  const params = new URLSearchParams(fragment.slice(1));
  if (!params.has('cap')) return null;

  const capability = String(params.get('cap') || '');
  const isPaymentLink = new URLSearchParams(window.location.search).get('step') === 'payment';

  // Remove the full fragment synchronously, before any network request or
  // rendered link can retain the capability in browser history/referrers.
  removeFragmentFromAddress();

  return isPaymentLink && CAPABILITY_PATTERN.test(capability) ? capability : '';
};

const normalizePaymentAction = (value) => {
  const token = String(value?.token || '');
  const orderId = Number(value?.orderId);
  const claims = decodeJwt(token);
  const userId = Number(claims?.sub || claims?.userid);

  if (
    !claims
    || claims.token_use !== 'action'
    || claims.auth_level !== 'email_link'
    || claims.scope !== 'wm:payment'
    || claims.resource_type !== 'order'
    || !String(claims.jti || '').trim()
    || !Number.isInteger(orderId)
    || orderId < 1
    || !Number.isInteger(userId)
    || userId < 1
    || Number(claims.resource_id) !== orderId
    || typeof claims.exp !== 'number'
    || claims.exp * 1000 <= Date.now()
  ) {
    return null;
  }

  return {
    token,
    orderId,
    userId,
    expiresAt: claims.exp * 1000,
  };
};

export const clearPaymentAction = () => {
  sessionStorage.removeItem(PAYMENT_ACTION_STORAGE_KEY);
};

export const getPaymentAction = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(PAYMENT_ACTION_STORAGE_KEY) || 'null');
    const action = normalizePaymentAction(stored);
    if (!action) clearPaymentAction();
    return action;
  } catch {
    clearPaymentAction();
    return null;
  }
};

export const storePaymentAction = (response = {}) => {
  const action = normalizePaymentAction({
    token: response.action_token,
    orderId: response.order_id,
  });

  if (
    !response.success
    || response.token_use !== 'action'
    || response.scope !== 'wm:payment'
    || !action
  ) {
    clearPaymentAction();
    return null;
  }

  sessionStorage.setItem(PAYMENT_ACTION_STORAGE_KEY, JSON.stringify(action));
  return action;
};

export const paymentActionMatchesOrder = (action, orderId) => (
  Boolean(action)
  && Number(action.orderId) === Number(orderId)
  && action.expiresAt > Date.now()
);
